import { fetchWithToken, CORE_BFF_BASE_URL } from "../platform-core";

interface FeatureStatus {
  Key: string;
  Enabled: boolean;
}

interface MyFeatures {
  Features: FeatureStatus[];
}

let myFeaturesPromise: Promise<MyFeatures> | undefined;

export const isFeatureEnabled = async (key: string) => {
  if (!myFeaturesPromise) {
    myFeaturesPromise = fetchWithToken(CORE_BFF_BASE_URL + "/v1/my/features", {
      method: "GET",
    }).then((response) => response.json());
  }
  return await myFeaturesPromise
    .then((myFeatures) => !!myFeatures.Features.find((feature) => feature.Key === key)?.Enabled)
    .catch((_error) => false);
};

export const clearMyFeaturesPromise = () => (myFeaturesPromise = undefined);
